import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withSnackbar } from 'notistack';

import { roles } from '../../services/user';

import pkg from '../../../package.json';

import history from '../../providers/history';

import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import MenuItem from '@angellira/menu-item';
import AngelliraDrawer from '@angellira/drawer';
import AngelLiraTopBar, { cancelSelection } from '@angellira/top-app-bar';

import AutorenewIcon from '@material-ui/icons/Autorenew';
import AssessmentIcon from '@material-ui/icons/Assessment';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import BeenhereIcon from '@material-ui/icons/Beenhere';

import { structureFooter, structureMain, link } from './style.css';
import { noPrint, noMarginPrint } from '../../static/print.css';
import { HomologatorConsumer } from '../homologator-context';

const component = connect(
  ({ mobile, topbar: { selection, title } }) => ({ mobile, selection, title }),
  bindActionCreators.bind(undefined, { cancelSelection })
);

class Structure extends Component {
  static defaultProps = {
    cancelSelection: Function.prototype
  };

  state = {
    drawerOpen: false,
  };

  toggleDrawer = () => this.setState({ drawerOpen: !this.state.drawerOpen });
  openDrawer = () => this.setState({ drawerOpen: true });
  closeDrawer = () => this.setState({ drawerOpen: false });

  enqueueSnackbar = (...args) => this.props.enqueueSnackbar && this.props.enqueueSnackbar(...args)

  handleLogout() {
    return history.push('/signout');
  }

  parseEnv(environment) {
    const env = environment.toUpperCase();
    const isMobile = this.props.mobile;

    return isMobile ? env.substr(0, 3) : env;
  }

  checkActive(exp) {
    return exp.test(window.location.pathname);
  }

  render() {
    const env = this.parseEnv(process.env.NODE_ENV);

    return <>
      <AngelLiraTopBar
        className={noPrint}
        selected={this.props.selection.length}
        env={env}
        title={this.props.title}
        onCancelSelection={this.props.cancelSelection}
        hideLogoText={this.props.mobile}
        onMenuClick={this.toggleDrawer}
        onLogoutClick={this.handleLogout}
        style={{ zIndex: this.props.mobile ? 1200 : 1210 }}
      />

      <AngelliraDrawer
        className={noPrint}
        style={{ paddingTop: '48px' }}
        minibar={!this.props.mobile}
        modal={this.props.mobile}
        open={this.state.drawerOpen}
        onMenuClick={this.toggleDrawer}
        onClose={this.closeDrawer}
      >
        <List component="nav">
          { roles('profile.query') &&
              <MenuItem
                key="0"
                icon={<FindInPageIcon/>}
                component={Link}
                to="/consulta"
                text="Consulta"
                iconOnly={!this.state.drawerOpen}
                active={this.checkActive(/^\/consulta$/)}
                button
              />
          }

          { roles('profile.register') &&
              <MenuItem
                key="1"
                icon={<InsertDriveFileIcon/>}
                text="Cadastro"
                iconOnly={!this.state.drawerOpen}
                collapsible
                onClick={this.openDrawer}
                active={this.checkActive(/\/cadastro$/)}
                button
              >
                <MenuItem
                  component={Link}
                  to="/motorista/cadastro"
                  text="Motorista"
                  onClick={this.closeDrawer}
                  active={this.checkActive(/^\/motorista\/cadastro$/)}
                  button
                />
                <MenuItem
                  component={Link}
                  to="/veiculo/cadastro"
                  text="Veículo"
                  active={this.checkActive(/^\/veiculo\/cadastro$/)}
                  onClick={this.closeDrawer}
                  button
                />
                <MenuItem
                  component={Link}
                  to="/proprietario/cadastro"
                  text="Proprietário"
                  active={this.checkActive(/^\/proprietario\/cadastro$/)}
                  onClick={this.closeDrawer}
                  button
                />
              </MenuItem>
          }

          { roles('profile.requery') &&
              <MenuItem
                key="2"
                icon={<AutorenewIcon/>}
                text="Recadastro"
                iconOnly={!this.state.drawerOpen}
                collapsible
                onClick={this.openDrawer}
                active={this.checkActive(/\/recadastro$/)}
                button
              >
                <MenuItem
                  component={Link}
                  to="/motorista/recadastro"
                  text="Motorista"
                  active={this.checkActive(/^\/motorista\/recadastro$/)}
                  onClick={this.closeDrawer}
                  button
                />
                <MenuItem
                  component={Link}
                  to="/veiculo/recadastro"
                  text="Veículo"
                  active={this.checkActive(/^\/veiculo\/recadastro$/)}
                  onClick={this.closeDrawer}
                  button
                />
                <HomologatorConsumer>
                  {({ hasIntegratedQuery })=> hasIntegratedQuery &&
                   (
                     <MenuItem
                       component={Link}
                       to="/integradas/recadastro"
                       text="Integradas"
                       active={this.checkActive(/^\/integradas\/recadastro$/)}
                       onClick={this.closeDrawer}
                       button
                     />
                   )
                  }
                </HomologatorConsumer>
              </MenuItem>
          }

          { roles('profile.report') &&
              <MenuItem
                key="3"
                icon={<AssessmentIcon/>}
                component={Link}
                to="/relatorio"
                text="Relatório"
                iconOnly={!this.state.drawerOpen}
                active={this.checkActive(/^\/relatorio|^\/consulta\/\d+\/retificacao$/)}
                button
              />
          }

          { roles('profile.certificate') &&
              <MenuItem
                key="4"
                icon={<BeenhereIcon/>}
                component={Link}
                to="/certificados"
                text="Certificados"
                iconOnly={!this.state.drawerOpen}
                active={this.checkActive(/^\/certificados$/)}
                button
              />
          }
        </List>
      </AngelliraDrawer>

      <main className={`drawerContent ${structureMain} ${noMarginPrint}`}>
        <div
          className={`${noMarginPrint}`}
          style={{flexGrow: 1, overflow: 'auto', backgroundColor: '#eaeaea'}}
          ref={el => this.contentEl = el}
        >
          {this.props.children}
        </div>

        <footer className={structureFooter}>
          <span style={{ display: 'flex' }}>
            Copyright &copy; {new Date().getFullYear()}
            {' '}
            ANGELLIRA TECNOLOGIA, SEGURANÇA E LOGÍSTICA LTDA.
            Todos os direitos reservados |
            <Typography color='inherit' variant="body2" className={link}
              onClick={() =>
                window.open('https://angellira.lgpd.express/app/policy#politica_de_privacidade')}
            > Política de Privacidade</Typography> e
            <Typography color='inherit' variant="body2" className={link}
              onClick={() =>
                window.open('https://politicacookies.angellira.com.br/')}
            > Política de Cookies.</Typography>
          </span>

          <span>Perfil Securitário | Versão {pkg.version}</span>
        </footer>
      </main>
    </>;
  }
}

export const connected = component(Structure);
export const snacked = withSnackbar(connected);

export default snacked;
